/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon64Regular = forwardRef('ArrowDRadiusDownRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M10 12.5C10 24.926 20.074 35 32.5 35h21.699a3.821 3.821 0 0 0-.838-1.23L38.447 19.068a1.5 1.5 0 1 1 2.106-2.136l14.914 14.702a6.833 6.833 0 0 1 0 9.733L40.553 56.068a1.5 1.5 0 1 1-2.106-2.136L53.361 39.23a3.82 3.82 0 0 0 .838-1.23H32.5C18.417 38 7 26.583 7 12.5v-2a1.5 1.5 0 1 1 3 0v2Z" })));
});
